import {
  DisplayFormulario,
  TipoCampoFormulario,
} from 'src/app/compartido/formulario/utilidades/formulario.models';
import { ConfiguracionFormulario } from 'src/app/compartido/formulario/utilidades/formulario.models';

/* Configuración del formulario de item */
export const CONFIGURACION_FORMULARIO_ITEM: ConfiguracionFormulario = {
  campos: [
    {
      nombre: 'Producto',
      slug: 'producto',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Cantidad',
      slug: 'cantidad',
      tipo: TipoCampoFormulario.NUMERO,
    },
  ],
  estilo: {
    display: DisplayFormulario.GRID,
  },
};
